import request from '@/router/axios';
import crypto from "@/util/crypto.js";

const decryptTransform = (data) => {
  try {
    return crypto.decrypt(data);
  } catch (error) {
    return data;
  }
};

const encryption = (data) => {
  const text = JSON.stringify(data);
  const key = crypto.encrypt(text);
  const formData = new FormData();
  formData.append('data', key);
  return formData;
};

// 新增线索（加密）
export const submitClue = (data) => {
  const formData = encryption(data);
  return request({
    url: "/api/ygj-integration/v2.0/channel-lead/submit",
    method: "post",
    data: formData,
    transformResponse: [decryptTransform],
  });
};
  

// 线索详情
export const getClueDetail = (id) => {
  return request({
    url: `/api/ygj-integration/v1.0/channel-lead/get/${id}`,
    method: "get"
  });
};

// 修改线索（加密）
export const updateClue = (data) => {
  const formData = encryption(data);
  return request({
    url: "/api/ygj-integration/v2.0/channel-lead/update",
    method: "PUT",
    data: formData,
    transformResponse: [decryptTransform],
  });
};

//第三方渠道线索关联企微好友选择分页查询
export const pageLeadSelect = (params) => {
  return request({
    url: "/api/ygj-integration/v1.0/external-contact/page-lead-select",
    method: "get",
    params: params
  });
};


//通过手机获取关联患者详情
// 患者详情分页查询
export const getPatientDetailPage = (params) => {
  return request({
    url: '/api/ygj-high-search/v1.0/hs-patient/detail-page',
    method: 'get',
    params: params
  });
};


// 线索管理分页查询（v2.0 加密）
export const listCluePage = (params) => {
  const formData = encryption(params);
  return request({
    url: '/api/ygj-datacenter/v2.0/channel-lead/list-page',
    method: 'post',
    data: formData,
    transformResponse: [decryptTransform],
  });
};

//我的线索查询分页（v2.0 加密）
export const listMyCluePage = (params) => {
  const formData = encryption(params);
  return request({
    url: '/api/ygj-datacenter/v2.0/channel-lead/list-my-page',
    method: 'post',
    data: formData,
    transformResponse: [decryptTransform],
  });
};




//删除线索
export const deleteClue = (params) => {
  return request({
    url: `/api/ygj-integration/v1.0/channel-lead/delete`,
    method: 'delete',
    params: params
  });
};

//线索关联企微好友
export const relateLeadWithWeComExternal = (params) => {
  return request({
    url: "/api/ygj-integration/v1.0/channel-lead/rel-wecom-external",
    method: "put",
    params: params
  });
};


//线索关联患者
export const relateLeadWithPatient = (params) => {
  return request({
    url: "/api/ygj-integration/v1.0/channel-lead/rel-patient",
    method: "put",
    params: params
  });
};

//获取线索集合
export const listClueByExternalUserId = (params) => {
  return request({
    url: '/api/ygj-integration/v1.0/channel-lead/list-by-external-user-id',
    method: 'get',
    params: params
  });
};


// 获取客户所有企微好友信息 
// http://192.168.0.201:30800/doc.html#/%E7%AC%AC%E4%B8%89%E6%96%B9%E9%9B%86%E6%88%90/[%20web%E5%89%8D%E7%AB%AF%20]%20%E4%BC%81%E5%BE%AE%E5%AE%A2%E6%88%B7(%E5%A5%BD%E5%8F%8B)%E4%BF%A1%E6%81%AF/getAllByUserIdUsingGET
// 获取客户所有企微好友信息
export const getAllExternalContactsByUserId = (params) => {
  return request({
    url: '/api/ygj-integration/v1.0/external-contact/get-all-by-user-id',
    method: 'get',
    params: params
  });
};

// 查看关联的患者
//http://192.168.0.201:30800/doc.html#/%E6%82%A3%E8%80%85%E7%AE%A1%E7%90%86/[%20web%E5%89%8D%E7%AB%AF%20]%20%E6%82%A3%E8%80%85%E4%BF%A1%E6%81%AF%E8%A1%A8%E6%8E%A5%E5%8F%A3/getDetailAllUsingGET

export const getAllPatientDetails = (params) => {
  return request({
    url: '/api/ygj-patient/v1.0/patient/detail-all/'+params.id,
    method: 'get',
  });
};


//线索批量创建线索跟进计划
export const batchSubmitFollowPlanForLead = (data) => {
  return request({
    url: '/api/ygj-patient/v1.0/follow-plan/batch-submit-for-lead',
    method: 'post',
    data: data
  });
};

//修改任务的跟进结果
export const updateFollowPlanRemark = (data) => {
  return request({
    url: '/api/ygj-patient/v1.0/follow-plan/update-remark',
    method: 'put',
    data: data
  });
};

//取消关联微信好友
//http://192.168.0.201:30800/doc.html#/%E7%AC%AC%E4%B8%89%E6%96%B9%E9%9B%86%E6%88%90/[%20web%E5%89%8D%E7%AB%AF%20]%20%E7%AC%AC%E4%B8%89%E6%96%B9%E6%B8%A0%E9%81%93%E7%BA%BF%E7%B4%A2/cancelPatientUsingPUT

export const unbindPatientFromWeComFriend = (params) => {
  return request({
    url: '/api/ygj-integration/v1.0/channel-lead/cancel-patient',
    method: 'put',
    params: params
  });
};

//线索取消关联企微好友
export const unbindWeComFriendFromLead = (params) => {
  return request({
    url: '/api/ygj-integration/v1.0/channel-lead/cancel-wecom-external',
    method: 'put',
    params:params
  });
};


//修改线索跟进人
export const updateLeadFollowEmployee = (data) => {
  return request({
    url: '/api/ygj-integration/v1.0/channel-lead/update-follow-employee',
    method: 'put',
    data: data
  });
};